import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { LabsReviewProvider, LabsReviewQueue, type LabsReviewModule } from '@ludolio/shared-labs';
import { labsReviewApi } from '@/services/api';

function getErrorMessage(error: unknown): string {
  const message = (error as { response?: { data?: { message?: unknown } } })?.response?.data?.message;
  return typeof message === 'string' ? message : 'Something went wrong. Please try again.';
}

export const Route = createFileRoute('/_authenticated/labs-reviews')({
  component: LabsReviewsPage,
});

function LabsReviewsPage() {
  const reviewModule = useMemo<LabsReviewModule>(() => ({ api: labsReviewApi, getErrorMessage }), []);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Labs reviews</h1>
      <LabsReviewProvider module={reviewModule}>
        <LabsReviewQueue scope="units" emptyMessage="No projects from your units are waiting for review" />
      </LabsReviewProvider>
    </div>
  );
}
